import PropTypes from 'prop-types';
import CV2Helper from '../../helpers/CV2Helper';
import DetailedTooltip from '../DetailedTooltip';

export function CV2Tooltip(props) {
  return (
    <DetailedTooltip
      title="checkout.payment.method.field.cv2.overlay.text.header"
      tooltipID={props.tooltipID}
    >
      <CV2Helper />
    </DetailedTooltip>
  );
}

CV2Tooltip.propTypes = {
  tooltipID: PropTypes.string.isRequired,
};

export default CV2Tooltip;
